import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SupplierService } from '../../../core/services/supplier.service';

@Component({
  selector: 'app-single-view-supplier-popup',
  templateUrl: './single-view-supplier-popup.component.html',
  styleUrls: ['./single-view-supplier-popup.component.scss'],
})
export class SingleViewSupplierPopupComponent implements OnInit {
  @Output() viewSupplierOnchange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible: boolean = false;
  supplierData: any;
  @Input() supplierId: any;
  loading = false;

  constructor(private supplierService: SupplierService) {}

  ngOnInit(): void {
    this.loading = true;
    this.supplierService.getSuppliersById(this.supplierId).then((res: any) => {
      this.loading = false;
      this.supplierData = res;
    });
  }

  ngOnDestroy(): void {
    this.supplierId = null;
    this.supplierData = null;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.viewSupplierOnchange.emit({
      name: 'isVisible',
      value: false,
    });
  }
}
